import dayjs from "dayjs";
import { Modal, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { useGlobalContext } from "../../context/GlobalContext";
import { API_CALCULATE_WAGES } from "../../utils/apis";
import { useToasts } from "../../hooks/common/useToasts";
import useSet from "../../hooks/common/useSet";

const { RangePicker } = DatePicker;

export const CalculateUserWages = () => {
  const { data, updateData } = useGlobalContext();
  const { openCalculateWage, staffId } = data || {};
  const { error, uploadData, success, submitting } = useSet();

  // default to the last seven days, one pay week ending today
  const [filters, setFilters] = useState<{
    period_start?: string;
    period_end?: string;
  }>({
    period_start: dayjs().subtract(6, "day").format("YYYY-MM-DD"),
    period_end: dayjs().format("YYYY-MM-DD"),
  });

  const handleClose = () => {
    updateData({
      openCalculateWage: false,
      staffId: null,
    });
  };

  useToasts({
    success,
    error,
    redirect: "reload",
    submitting,
    successMessage: "Wages calculated successfully",
  });

  const handleSync = () => {
    if (!filters.period_start || !filters.period_end) return;

    const params: any = {
      period_start: filters.period_start,
      period_end: filters.period_end,
    };

    if (staffId) {
      params.staff_id = staffId;
    }

    uploadData({
      api: `${API_CALCULATE_WAGES}`,
      params,
    });
  };

  // Track loading from useGet to close modal or show toast
  useEffect(() => {
    if (!submitting && success) {
      handleClose();
    }
  }, [submitting, success]);

  return (
    <Modal
      open={!!openCalculateWage}
      title="Calculate Weekly Wages"
      onCancel={handleClose}
      onOk={handleSync}
      okText="Calculate"
      confirmLoading={submitting}
      okButtonProps={{ disabled: !filters.period_start || !filters.period_end }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <label>Select Date Range</label>
        <RangePicker
          value={
            filters.period_start && filters.period_end
              ? [dayjs(filters.period_start), dayjs(filters.period_end)]
              : null
          }
          onChange={(dates) =>
            setFilters({
              period_start: dates?.[0]?.format("YYYY-MM-DD"),
              period_end: dates?.[1]?.format("YYYY-MM-DD"),
            })
          }
        />
      </div>
    </Modal>
  );
};
